module.exports = __webpack_public_path__ + "img/success_c.f3608028.gif";